import React, { FC, useEffect, lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Loader from '../components/Loader';
import SiteHeader from '../components/SiteHeader';
import PageNotFound from '../views/404';
import { OfficialStatementJSON } from '../views/OfficialStatement/OfficialStatementJSON';
import { getConstantsThunk } from '../ducks/general/thunk';
import { ThunkAppDispatch } from '../store';
import { PageFooter } from '../components/PageFooter';
import 'react-toastify/dist/ReactToastify.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './styles/index.scss';

const OfficialStatement = lazy(
  () =>
    import(
      /* webpackChunkName: "OfficialStatement" */ /* webpackPreload: true */ '../views/OfficialStatement'
    ),
);

const TransactionsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "transactions" */ /* webpackPreload: true */ '../views/Transactions'
    ),
);

const Blocks = lazy(
  () => import(/* webpackChunkName: "blocks" */ /* webpackPreload: true */ '../views/Blocks'),
);

const Account = lazy(
  () => import(/* webpackChunkName: "account" */ /* webpackPreload: true */ '../views/Accounts'),
);

const PeerPage = lazy(
  () => import(/* webpackChunkName: "peers" */ /* webpackPreload: true */ '../views/Peers'),
);

const GenesisBalances = lazy(
  () =>
    import(
      /* webpackChunkName: "GenesisBalances" */ /* webpackPreload: true */ '../views/GenesisBalances'
    ),
);

const App: FC = () => {
  const dispatch = useDispatch<ThunkAppDispatch>();

  useEffect(() => {
    dispatch(getConstantsThunk());
  }, [dispatch]);

  if (document.location.pathname.includes('/official-statement/json')) {
    return <Route exact path='/official-statement/json' component={OfficialStatementJSON} />;
  } else {
    return (
      <React.Fragment>
        <ToastContainer />
        <SiteHeader />
        <main className='content'>
          <Suspense fallback={<Loader />}>
            <Switch>
              <Route exact path={'/'} component={OfficialStatement} />
              <Route exact path={'/transactions'} component={TransactionsPage} />
              <Route exact path={'/transactions/:transaction'} component={TransactionsPage} />
              <Route exact path={'/transactions/accountId/:account'} component={TransactionsPage} />
              <Route
                exact
                path={'/transactions/accountId/:account/:transaction'}
                component={TransactionsPage}
              />

              <Route exact path={'/transactions/currency/:code'} component={TransactionsPage} />
              <Route
                exact
                path={'/transactions/currency/:code/:transaction'}
                component={TransactionsPage}
              />
              <Route exact path={'/blocks'} component={Blocks} />
              <Route exact path={'/blocks/:block'} component={Blocks} />
              <Route exact path={'/blocks/:block/:transaction'} component={Blocks} />
              <Route exact path={'/accounts'} component={Account} />
              <Route exact path={'/accounts/:account'} component={Account} />
              <Route exact path={'/peers/'} component={PeerPage} />
              <Route exact path={'/peers/:peer'} component={PeerPage} />

              <Route exact path={'/nxt-airdrop'} component={GenesisBalances} />
              {/* <Route exact path={'/top-holders'}       component={TopHolders}            /> */}
              {/* <Route exact path={'/foundation-wallets'}component={FoundationWallets}            /> */}
              <Route exact path={'*'} component={PageNotFound} />
            </Switch>
          </Suspense>
        </main>
        <PageFooter />
      </React.Fragment>
    );
  }
};

export default App;
